import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { saveCompany, setCompanyLogo } from "@/lib/api/company";
import { getWorkspace } from "@/lib/api/workspaces";
import { companyOf } from "@/lib/workspace/company";
import { useCurrentWorkspace } from "@/lib/workspace/workspace-context";
import { workspaceKeys } from "./use-workspace";

/** The current workspace's company (shares the cache of useWorkspace()). */
export function useCompany({ enabled = true }: { enabled?: boolean } = {}) {
  const { workspaceId } = useCurrentWorkspace();
  return useQuery({
    queryKey: workspaceKeys.current(workspaceId ?? ""),
    queryFn: getWorkspace,
    enabled: enabled && Boolean(workspaceId),
    select: companyOf,
  });
}

export function useSaveCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveCompany,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: workspaceKeys.all }),
  });
}

export function useCompanyLogo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: setCompanyLogo,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: workspaceKeys.all }),
  });
}
